export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
    seriesError: 'Je třeba vybrat alespoň jednu možnost',
  },
  calculator: {
    title: 'Výpočet úspor v aplikaci Walutomat',
    forBuy: 'pro',
    unsupportedPair: 'V současné době nenabízíme kurzy pro vybraný měnový pár.',
    spinnerError: {
      generic: 'Při stahování dat došlo k problému',
      toManyRequests:
        'Kalkulátor je momentálně nedostupný. Zkuste to prosím později nebo se obraťte na <a href="https://www.walutomat.com/cs/kontakt/">Zákaznický Servis</a>.',
    },
    commissionWT: 'Provize Walutomatu',
    ctaButton: 'Směnit',
    amountText: 'Částka',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Zkontrolujte kurzy a{{nbsp}}směňte měnu v{{nbsp}}Walutomat – rychle a{{nbsp}}výhodně.',
    actualRate: 'Aktuální kurz',
    buySelect: 'Kupuji',
    sellSelect: 'Prodávám',
    exchangeAmountSellLabel: 'Získáte',
    exchangeAmountBuyLabel: 'Vložte',
    commission: 'Propagační provize ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Pole nemůže být prázdné',
    requiredField: 'Pole je povinné',
    requireAllFields: 'Všechna pole musí být vyplněna',
    passwordToShort: 'Heslo musí mít 8 znaků',
    emailNotValid: 'Pole musí obsahovat platnou e-mailovou adresu',
    emailReserved: 'E-mailová adresa je již obsazena',
    emailUnregistered: 'Vaši e-mailovou adresu jsme nenašli v naší databázi zákazníků.',
    markField: 'Vyberte alespoň jedno z políček',
    serverUnknownError: 'Chyba komunikace se serverem',
    invalidCharacters: 'Pole obsahuje neplatné znaky',
    phoneNotValid: 'Telefonní číslo je nesprávné',
    checkBoxBelow: 'Pro odeslání zprávy zaškrtněte políčko níže',
    promocodeInvalid: 'Neplatný propagační kód',
    newsletterAlreadySubscribed: 'Tento e-mail je již přihlášen k odběru newsletteru.',
  },
  password: {
    show: 'zobrazit',
    hide: 'skrýt',
  },
  howItWorks: {
    showButton: 'Zobrazit více',
    hideButton: 'Zobrazit méně',
  },
  rateCalculator: {
    baseInputLabel: 'Mam',
    counterInputLabel: 'Otrzymam',
    counterInputTooltip: 'Uwzględnia prowizję {{commission}}%',
    ctaAlert: 'Ustaw alert',
  },
  esim: {
    searchPlaceholder: 'Vyhledejte zemi nebo region...',
    searchAriaLabel: 'Vyhledejte zemi nebo region',
    searchMinChars: 'Zadejte <b>alespoň 3 znaky</b> pro zobrazení výsledků.',
    searchNoResults: '<b>Žádné výsledky.</b> Hledaná země nebyla nalezena.',
    searchError: '<b>Došlo k chybě.</b> Nepodařilo se načíst seznam nabídek.',
  },
}
